import ProfileView from './components/ProfileView/';
import AboutRoute from './routes/About/';
import CoachingPreferencesRoute from './routes/CoachingPreferences/';
import EducationRoute from './routes/Education/';
import ExperienceRoute from './routes/Experience/';
import SelfIntroRoute from './routes/SelfIntro/';

import LoginHOC from '../../../../components/LoginHOC';

export default (store) => ({
  path: 'profile',
  component: LoginHOC(ProfileView),
  indexRoute: AboutRoute(store),
  childRoutes: [
    AboutRoute(store),
    CoachingPreferencesRoute(store),
    EducationRoute(store),
    ExperienceRoute(store),
    SelfIntroRoute(store)
  ]
});



// WEBPACK FOOTER //
// ./src/routes/advisor/routes/Profile/index.js